export default __webpack_public_path__ + "static/delete_image-a40a8374633251da06e2bfc518339a5c.gif";